export default {
    // sale deal type
    sale: {
        deal_type: 'sale',
        fields: [

        ]
    },
    new_letting: {
        deal_type: 'new_letting',
        fields: [
            'property_id',
            'reason',
            'tenant_id',
            'tenant_legal_id',
            'landlords',
            'landlord_agents',
            'landlord_contacts',
            'landlord_agent_contacts',
            'tenant_agents',
            'tenant_agents_contacts',
            'tenant_contacts',
            'lease_start_date',
            'lease_end_date',
            'rent_review_clause',
            'rent_review_date',
            'break_clause',
            'break_date',
            'rent_pa',
            'rent_sqft',
            'rateable_value',
            'service_charge',
            'incentive',
            'currency',
            'planning',
            'areas',
            'address',
        ],
        sections: [
            'property',
            'contacts',
            'lease',
            
        ]
    }
}